
// --- Vue & Template imports ---
import { Component, Vue} from 'vue-property-decorator';

// --- Models ---
import { DailyYardVehicle } from '@/models/DailyYardVehicle';

// --- Services ---
import AppService from '@/services/app';
import DailyYardVehicleService from '@/services/dailyYardVehicle';
import VehicleService from '@/services/vehicle';

// --- Third Party ---
import dayjs from 'dayjs';

@Component
export default class SearchYardList extends Vue {

  // used by Filter Area
  startDatePicker: boolean = false;
  startDate: string = dayjs().format('YYYY-MM-DD');

  searchClicked: boolean = false;

  searchResults: DailyYardVehicle[] = [];

  // #region Functions to display list data on page load
    headers() {
      return [
        {
          text: 'Vehicle',
          value: 'vehicle1',
        },
        {
          text: 'Linked Trailer',
          value: 'vehicle2',
        },
        {
          text: 'Status',
          value: 'status',
        },
        {
          text: 'Comment',
          value: 'comment',
        }
      ];
    }

    customSort(items: any[], sortBy: string[], sortDesc: boolean[], locale: string) {
      // If the result is negative, a is sorted before b.
      // If the result is positive, b is sorted before a.
      // If the result is 0, no changes are done with the sort order of the two values.

      switch (sortBy[0]) {
        case 'vehicle1':
          if (sortDesc[0]) {
            items.sort((a: DailyYardVehicle, b: DailyYardVehicle) => a.vehicle1Code.toLowerCase().localeCompare(b.vehicle1Code.toLowerCase()));
          } else {
            items.sort((a: DailyYardVehicle, b: DailyYardVehicle) => b.vehicle1Code.toLowerCase().localeCompare(a.vehicle1Code.toLowerCase()));
          }
          break;

        case 'vehicle2':
          if (sortDesc[0]) {
            items.sort((a: DailyYardVehicle, b: DailyYardVehicle) => (a.vehicle2Code ? a.vehicle2Code : '').toLowerCase().localeCompare((b.vehicle2Code ? b.vehicle2Code : '').toLowerCase()));
          } else {
            items.sort((a: DailyYardVehicle, b: DailyYardVehicle) => (b.vehicle2Code ? b.vehicle2Code : '').toLowerCase().localeCompare((a.vehicle2Code ? a.vehicle2Code : '').toLowerCase()));
          }
          break;

        case 'status':
          if (sortDesc[0]) {
            items.sort((a: DailyYardVehicle, b: DailyYardVehicle) => a.status.toLowerCase().localeCompare(b.status.toLowerCase()));
          } else {
            items.sort((a: DailyYardVehicle, b: DailyYardVehicle) => b.status.toLowerCase().localeCompare(a.status.toLowerCase()));
          }
          break;
      }

      return items;
    }

    async beforeMount() {
      await VehicleService.listTypes(false);
      await VehicleService.listActive(true);
    }

    getToday() {
      return dayjs().format('YYYY-MM-DD');
    }

    async search() {
      try {
        this.searchClicked = true;

        const response = await DailyYardVehicleService.search({ params: {
          date: this.startDate,
        }});

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            AppService.errorHandler(response.data.message);
            this.searchResults = [];
          } else {
            this.searchResults = response.data;
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          AppService.logSupportDebug('Search_YardList.vue - search - 163 - ' + error);
          AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
        }

      } finally {
        this.searchClicked = false;
      }
    }

    getVehicleById(vehicleId: number) {
      return this.$store.getters['vehicles/vehicleById'](vehicleId);
    }
  // #endregion

}
